<script setup lang="ts">
import SkeletonLoader from '@/components/base/skeleton/SkeletonLoader.vue'
</script>
<template>
  <div grid grid-cols-1 md:grid-cols-2 gap-3 px-2 mt-6>
    <div v-for="(item, index) in [0, 1, 2]" w-full h-133 p-4 :key="index" bg-card>
      <SkeletonLoader class="w-full h-4" my-2 mt-4 />
      <SkeletonLoader class="w-full h-4" my-2 />
      <SkeletonLoader class="w-full h-4" my-2 />
      <SkeletonLoader class="w-6/12 h-4" my-2 />
      <div grid grid-cols-2 gap-2 mt-4>
        <SkeletonLoader v-for="item in [0, 1, 2]" class="w-full h-36" />
      </div>
      <div w-full flex="~ row" items-center mt-8>
        <SkeletonLoader type="circle" mr-3 h-8 w-8 />
        <div flex="~ col" grow>
          <div flex="~ row" items-baseline text-sm>
            <SkeletonLoader class="w-30 h-4" pt-0.5 />
            <SkeletonLoader class="w-12 h-4" ml-2 />
          </div>
          <SkeletonLoader class="w-24 h-4" mt-2 />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
